import { SPACE_SIZE_VALUES } from "constants/constants";
import { stopBuzzSound } from "helpers/sounds";
import { selectSpaceSize } from "slices/spaceMediaSlice";
import {
  moveIfColliding,
  resetDragging,
  setXOffset,
  setYOffset,
  xOffset,
  yOffset,
} from "./spaceDrag";
import { drawMe, drawOtherPerson, scaleAllPositions } from "./spaceDraws";
import {
  calcAllD2M,
  calcOneD2M,
  handleMediaMagnitude,
  checkMedia2Change,
  resetMedia2Change,
  resetAllMedia,
} from "./spaceMediaPhysics";
import { stopTests, testStarted } from "./spaceTest";
import { xPcntToPx, yPcntToPx } from "./spaceUtil";
import {
  people,
  setavatarCircle,
  avatarCircle,
  setmyCircle,
  SsetMyLuid,
  resetpeople,
  SPACEBOX,
  myLuid,
  setMediaRanges,
  setSpaceBoxWidth,
  setSpaceBoxHeight,
  spaceBoxHeight,
  setEdgeBuffer,
  spaceBoxWidth,
  setFontHeight,
  fontHeight,
} from "./spaceVars";
// let dispatch = null;
let getState = null;
import("Store").then((module) => {
  // dispatch = module.store.dispatch;
  getState = module.store.getState;
});

export function setOtherPeople(newPeople) {
  for (var luid in newPeople) {
    setPerson(newPeople[luid]);
    drawOtherPerson(people[luid]);
  }
}

function setPerson(person) {
  people[person.luid] = { ...person };
  people[person.luid].x = xPcntToPx(people[person.luid].x);
  people[person.luid].y = yPcntToPx(people[person.luid].y);
}

export function setGraphicMe(person) {
  SsetMyLuid(person.luid);
  setPerson(person);
  drawMe(people[myLuid]);
}

export function setNewPerson(person) {
  let luid = person.luid;
  setPerson(person);
  drawOtherPerson(people[luid]);
  calcOneD2M(
    people[myLuid].x,
    people[myLuid].y,
    people[luid].x,
    people[luid].y,
    luid
  );
  checkMedia2Change(luid);
  handleMediaMagnitude(
    luid,
    people[luid].d2me,
    people[luid].shout,
    people[luid].pinnedShare
  );
}

export function loadGraphicSpace() {
  onWindowChangeSpace();
  calcAllD2M();
  resetAllMedia();
}

export async function unloadGraphicSpace() {
  if (testStarted) {
    stopTests();
    setTimeout(() => {
      resetSpace();
      return;
    }, 2000);
  } else {
    resetSpace();
  }
}

function resetSpace() {
  for (var luid in avatarCircle) {
    SPACEBOX.removeChild(avatarCircle[luid]);
  }
  setmyCircle(null);
  SsetMyLuid(null);
  setavatarCircle({});
  resetMedia2Change();
  resetpeople();

  resetDragging();
  stopBuzzSound();
}

let throttling = false;
let throttlingTime = 300;
const throttleOnWindowChangeSpace = () => {
  if (throttling) return;
  throttling = true;
  setTimeout(() => {
    throttling = false;
    onWindowChangeSpace();
  }, throttlingTime);
};

export function onWindowChangeSpace() {
  let newSpaceBoxWidth = SPACEBOX.getBoundingClientRect().width;
  let newSpaceBoxHeight = SPACEBOX.getBoundingClientRect().height;
  let reduceRatio = newSpaceBoxHeight / spaceBoxHeight;
  scaleAllPositions(reduceRatio);
  // Setting it in Redux store
  // Setting it in Graphic Space mutable values as well
  // - for performance when calculating movements;
  setSpaceBoxWidth(newSpaceBoxWidth);
  setSpaceBoxHeight(newSpaceBoxHeight);

  let spaceSize = selectSpaceSize(getState());
  setMediaRanges(newSpaceBoxHeight * SPACE_SIZE_VALUES[spaceSize].mr2h);
  setEdgeBuffer(SPACE_SIZE_VALUES[spaceSize].eBuff, spaceBoxWidth);
  setFontHeight(SPACE_SIZE_VALUES[spaceSize].fs * newSpaceBoxHeight);

  SPACEBOX.style.fontSize = fontHeight.toString() + "px";

  if (reduceRatio) {
    setXOffset(xOffset * reduceRatio);
    setYOffset(yOffset * reduceRatio);
  }

  // Move when peoples sizes change and they might be overflowing
  // the SPACEBOX or slightly on top of others
  moveIfColliding();
}

window.addEventListener("resize", throttleOnWindowChangeSpace);
window.addEventListener("load", onWindowChangeSpace);
